import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {CmsServiceTable} from './table/CmsServiceTable'
import {CmsServiceEditModal} from './cms-services-edit-modal/CmsServiceEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {CmsServiceListHeader} from './header/CmsServiceListHeader'
import { ToastContainer } from 'react-toastify'

const CmsServiceList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ToastContainer/>
        <CmsServiceListHeader />
        <CmsServiceTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <CmsServiceEditModal />}
    </>
  )
}

const CmsServiceListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <CmsServiceList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {CmsServiceListWrapper}
